{
  "boards": {
    "title": "Boards",
    "internalReportName": "dashboards"
  },
  "metric-tree": {
    "title": "Metric Tree",
    "internalReportName": "metric-tree"
  },
  "experiments": {
    "title": "Experiments",
    "internalReportName": "experiments"
  },
  "heatmaps": {
    "title": "Heatmaps",
    "internalReportName": "heatmaps"
  },
  "home": {
    "title": "Home",
    "internalReportName": "home"
  },
  "flows": {
    "title": "Flows",
    "internalReportName": "flows"
  },
  "funnels": {
    "title": "Funnels",
    "internalReportName": "funnels"
  },
  "insights": {
    "title": "Insights",
    "internalReportName": "insights"
  },
  "retention": {
    "title": "Retention",
    "internalReportName": "retention"
  },
  "events": {
    "title": "Events",
    "internalReportName": "events"
  },
  "users": {
    "title": "Users",
    "internalReportName": "users"
  },
  "profile": {
    "title": "Profile",
    "internalReportName": "profile"
  },
  "lexicon": {
    "title": "Lexicon",
    "internalReportName": "lexicon"
  },
  "entity-management": {
    "title": "Entity Management",
    "internalReportName": "entity-management"
  },
  "destinations": {
    "title": "Destinations",
    "internalReportName": "integrations"
  },
  "signal": {
    "title": "Signal",
    "internalReportName": "signal"
  },
  "impact": {
    "title": "Impact",
    "internalReportName": "impact"
  },
  "experiment-reporting": {
    "title": "Experiments",
    "internalReportName": "experiment-reporting"
  },
  "jql-console": {
    "title": "JQL",
    "internalReportName": "jql-console"
  },
  "settings": {
    "title": "Settings",
    "internalReportName": "settings"
  },
  "views": {
    "title": "Data Views",
    "internalReportName": "views"
  },
  "admin-org-settings": {
    "title": "Admin Organization Settings",
    "internalReportName": "admin-org-settings"
  },
  "feature-flags": {
    "title": "Feature Flags",
    "internalReportName": "feature-flags"
  },
  "agent-flows": {
    "title": "Automations",
    "internalReportName": "agent-flows"
  },
  "session-replay": {
    "title": "Session Replay",
    "internalReportName": "session-replay"
  },
  "agent": {
    "title": "Mixpanel Agent",
    "internalReportName": "agent"
  },
  "agent-intelligence": {
    "title": "Agent Intelligence",
    "internalReportName": "agent-intelligence"
  }
}
